// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__2aYQj","panel":"Settings_panel__1waU6","inputGroup":"Settings_inputGroup__3YOH_","buttonGroup":"Settings_buttonGroup__3FbIi"};